var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHandwritting = function SvgHandwritting(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 28.21875,
    y1: 119.679749,
    x2: 28.21875,
    y2: 161.078003,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 40.3125,
    y1: 119.679749,
    x2: 40.3125,
    y2: 161.078003,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 18.4685,
    x2: 86,
    y2: 159.830994,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 80.625,
    y1: 35.195499,
    x2: 80.625,
    y2: 48.235249,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8488769"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 7.03125 35.9375 L 9.375 35.9375 L 9.375 37.5 L 7.03125 37.5 Z M 7.03125 35.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 7.421875 43.75 C 6.777344 43.75 6.25 43.222656 6.25 42.578125 C 6.25 41.933594 6.777344 41.40625 7.421875 41.40625 L 13.671875 41.40625 C 15.179688 41.40625 16.40625 40.179688 16.40625 38.671875 C 16.40625 37.164062 15.179688 35.9375 13.671875 35.9375 L 10.9375 35.9375 L 10.9375 37.5 L 13.671875 37.5 C 14.316406 37.5 14.84375 38.027344 14.84375 38.671875 C 14.84375 39.316406 14.316406 39.84375 13.671875 39.84375 L 7.421875 39.84375 C 5.914062 39.84375 4.6875 41.070312 4.6875 42.578125 C 4.6875 44.085938 5.914062 45.3125 7.421875 45.3125 L 18.75 45.3125 L 18.75 43.75 Z M 7.421875 43.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 42.96875 7.8125 L 39.84375 7.8125 C 38.550781 7.8125 37.5 8.863281 37.5 10.15625 L 37.5 11.71875 L 28.125 11.71875 L 28.125 10.15625 C 28.125 9.722656 27.773438 9.375 27.34375 9.375 L 27.34375 8.203125 C 27.34375 6.265625 25.589844 4.6875 23.4375 4.6875 C 21.285156 4.6875 19.53125 6.265625 19.53125 8.203125 L 19.53125 9.375 C 19.101562 9.375 18.75 9.722656 18.75 10.15625 L 18.75 11.71875 L 7.8125 11.71875 C 6.089844 11.71875 4.6875 13.121094 4.6875 14.84375 C 4.6875 16.566406 6.089844 17.96875 7.8125 17.96875 L 18.75 17.96875 L 18.75 17.996094 C 16.269531 20.011719 14.84375 22.960938 14.84375 26.171875 C 14.84375 29.382812 16.269531 32.332031 18.75 34.347656 L 18.75 38.28125 C 18.75 38.285156 18.75 38.289062 18.753906 38.289062 C 18.753906 38.339844 18.773438 38.390625 18.78125 38.441406 C 18.792969 38.492188 18.796875 38.546875 18.816406 38.59375 C 18.820312 38.597656 18.820312 38.601562 18.820312 38.605469 L 21.402344 44.296875 C 21.414062 44.328125 21.433594 44.359375 21.449219 44.386719 C 21.882812 45.078125 22.625 45.488281 23.4375 45.488281 C 24.25 45.488281 24.996094 45.078125 25.425781 44.386719 C 25.445312 44.359375 25.460938 44.328125 25.476562 44.296875 L 28.054688 38.605469 C 28.058594 38.601562 28.058594 38.597656 28.058594 38.59375 C 28.078125 38.546875 28.082031 38.492188 28.09375 38.441406 C 28.105469 38.390625 28.125 38.339844 28.125 38.289062 C 28.125 38.289062 28.125 38.285156 28.125 38.28125 L 28.125 36.3125 C 28.324219 36.285156 28.527344 36.246094 28.726562 36.179688 C 33.144531 34.710938 36.105469 30.425781 35.929688 25.761719 C 35.917969 25.457031 35.894531 25.152344 35.855469 24.847656 L 37.597656 24.847656 C 37.875 25.832031 38.769531 26.5625 39.84375 26.5625 L 42.96875 26.5625 C 44.261719 26.5625 45.3125 25.511719 45.3125 24.21875 L 45.3125 10.15625 C 45.3125 8.863281 44.261719 7.8125 42.96875 7.8125 Z M 18.75 32.207031 C 17.253906 30.566406 16.40625 28.449219 16.40625 26.171875 C 16.40625 23.894531 17.253906 21.777344 18.75 20.136719 Z M 18.75 16.40625 L 7.8125 16.40625 C 6.949219 16.40625 6.25 15.707031 6.25 14.84375 C 6.25 13.980469 6.949219 13.28125 7.8125 13.28125 L 18.75 13.28125 Z M 28.125 22.867188 C 29.101562 23.671875 29.6875 24.863281 29.6875 26.171875 C 29.6875 27.480469 29.089844 28.675781 28.125 29.472656 Z M 21.09375 8.203125 C 21.09375 7.125 22.144531 6.25 23.4375 6.25 C 24.730469 6.25 25.78125 7.125 25.78125 8.203125 L 25.78125 9.375 L 21.09375 9.375 Z M 20.3125 10.9375 L 26.5625 10.9375 L 26.5625 13.28125 L 20.3125 13.28125 Z M 24.714844 42.1875 L 22.160156 42.1875 L 20.742188 39.0625 L 26.132812 39.0625 Z M 26.5625 37.5 L 20.3125 37.5 L 20.3125 29.6875 L 23.4375 29.6875 L 23.4375 28.125 L 20.3125 28.125 L 20.3125 26.5625 L 23.4375 26.5625 L 23.4375 25 L 20.3125 25 L 20.3125 23.4375 L 23.4375 23.4375 L 23.4375 21.875 L 20.3125 21.875 L 20.3125 14.84375 L 26.5625 14.84375 L 26.5625 30.300781 C 26.5625 30.3125 26.566406 30.320312 26.566406 30.328125 C 25.390625 30.816406 24.609375 31.945312 24.609375 33.210938 C 24.609375 34.230469 25.082031 35.152344 25.910156 35.75 C 26.117188 35.898438 26.335938 36.007812 26.5625 36.101562 Z M 34.160156 24.238281 C 34.277344 24.757812 34.347656 25.289062 34.367188 25.820312 C 34.519531 29.792969 31.996094 33.445312 28.230469 34.699219 C 27.75 34.855469 27.238281 34.777344 26.824219 34.480469 C 26.410156 34.183594 26.171875 33.71875 26.171875 33.210938 C 26.171875 32.542969 26.613281 31.945312 27.265625 31.722656 C 29.648438 30.921875 31.25 28.6875 31.25 26.171875 C 31.25 23.980469 30.054688 22.019531 28.125 21 L 28.125 13.28125 L 37.5 13.28125 L 37.5 23.285156 L 33.949219 23.285156 Z M 43.75 24.21875 C 43.75 24.648438 43.398438 25 42.96875 25 L 42.1875 25 L 42.1875 20.3125 L 40.625 20.3125 L 40.625 25 L 39.84375 25 C 39.414062 25 39.0625 24.648438 39.0625 24.21875 L 39.0625 10.15625 C 39.0625 9.726562 39.414062 9.375 39.84375 9.375 L 42.96875 9.375 C 43.398438 9.375 43.75 9.726562 43.75 10.15625 Z M 43.75 24.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 20.3125 10.9375 L 26.5625 10.9375 L 26.5625 13.28125 L 20.3125 13.28125 Z M 20.3125 10.9375 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHandwritting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/handwritting.f97f04b0.svg";
export { ForwardRef as ReactComponent };